import { UploadFile } from "antd";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";

/**
 * files service handles the raw multipart streaming of images directly substituting S3 endpoints.
 * Mounts standard `UploadFile` AntD instances mapped into byte Blobs natively.
 */
export const files = async ({
  file,
  category,
}: {
  file: UploadFile | null;
  category: string;
}) => {
  if (file) {
    try {
      const formData = new FormData();
      let targetFile = file as any;
      if (targetFile.originFileObj) {
         targetFile = targetFile.originFileObj;
      }
      formData.append("file", targetFile as Blob);
      formData.append("category", category || "general");

      const response = await axios.post(`${API_URL}/files/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return { path: response.data.path };
    } catch (e) {
      console.log("Error subiendo imagen al backend local", e);
      return null;
    }
  } else {
    throw new Error("Imagen obligatoria");
  }
};

export const deleteFile = async (path: string) => {
  // Not implemented in backend yet, doing nothing
  console.log("Not implemented: deleteFile", path);
};

/**
 * downloadFile resolves physical relative URIs natively via Local Go routing instead of Presigned URLs.
 * Replaces S3 mappings allowing generic browser <a> routing directly interacting with `./uploads/`.
 */
export const downloadFile = async (path: string, type: string) => {
  try {
    if (!path) return "";
    
    // Apuntamos directo a nuestra carpeta estática servida por GO
    return `${API_URL}/uploads/${path}`;
  } catch (e) {
    console.log("Error descargando imagen", e);
    return "";
  }
};
